module.exports = __webpack_public_path__ + "img/tix.e6105e5c.svg";